'use strict';

var request = require('./blueAgent');
var assign = require('object-assign');
var ServiceClientBase = require('./serviceClientBase');
var promise = require('bluebird');
var legacyIESupport = require('superagent-legacyiesupport');
var StringHelper = require('../lib/StringHelper.js');

var defaults = {};

module.exports = assign({}, ServiceClientBase.prototype, {

    /**
     * @param params
     * @param {string} params.token
     * @param {string} params.deviceId
     * @returns {Bluebird Promise}
     */

    getApiRequest: function getApiRequest(url, queryString, headers) {
        var legacyIESupportWrapper = function legacyIESupportWrapper(superagent) {
            if (typeof XDomainRequest !== "undefined" // IE 8, 9, & 10
            && !('withCredentials' in new XMLHttpRequest())) {
                //ONLY IE10
                //use the legacy support page
                legacyIESupport(superagent);
            }
        };

        var defaults = {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        };

        if (headers) {
            for (var prop in headers) {
                defaults[prop] = headers[prop];
            }
        }

        //safari is caching OPTIONS requests and replaying them as GET requests.
        //passing in cache-control fixs this.
        try {
            if (navigator && navigator.vendor && navigator.vendor.indexOf('Apple') > -1) {
                if (!defaults['cache-control']) {
                    defaults['cache-control'] = 'no-cache';
                }
            }
        } catch (e) {
            console.log("Error trying to set 'cache-control' for safari OPTIONS bug", e);
        }

        if (queryString) {
            if (queryString.token) {
                delete queryString.token;
            }
            if (queryString.deviceId) {
                delete queryString.deviceId;
            }
        }

        return request.get(url).use(legacyIESupportWrapper).query(queryString).set(defaults).send().then(function (data) {
            if (data.body) {
                return promise.resolve(data.body);
            }
        }, function (err) {
            return promise.reject(err);
        });
    },

    getByID: function getByID(id, lang) {
        var params = { id: id };
        if (lang) {
            if (lang == "es" || lang == "fr") {
                params = {
                    id: id,
                    lang: lang
                };
            }
        }

        return this.getApiRequest(this.getUrl().careersByIds, params);
    },

    getJobLocationSuggestion: function getJobLocationSuggestion(term) {
        return this.getApiRequest(this.getUrl().careersSuggestions, { term: term });
    },
    getJobsByKeywordAndLocation: function getJobsByKeywordAndLocation(inKey, inLocation, lang, categoryCode, start, rows) {
        //temporary until I deploy new wendysjobservice endpoints
        // if(inLocation && inLocation.latitude !== undefined) {
        //     return this.getJobsByKeywordAndLatLong(inKey, inLocation.latitude, inLocation.longitude, lang, categoryCode, start, rows);
        // } else {
        return this.getJobsByKeywordAndAddress(inKey, inLocation, lang, categoryCode, start, rows);
        // }
    },
    getJobsByKeywordAndAddress: function getJobsByKeywordAndAddress(inKey, inLocation, lang, categoryCode, start, rows) {
        var params = {
            keys: StringHelper.removeSpecialCharacters(inKey),
            location: inLocation,
            d: 50,
            start: start || 0,
            rows: rows || 50,
            category: categoryCode || 'ALL',
            lang: lang && (lang == "es" || lang == "fr") ? lang : 'en'
        };

        return this.getApiRequest(this.getUrl().careersByKeywordsAndLocation, params);
    },
    getJobsByKeywordAndLatLong: function getJobsByKeywordAndLatLong(inKey, lat, long, lang, categoryCode, start, rows) {
        var params = {
            category: categoryCode || 'ALL',
            lang: lang && (lang == "es" || lang == "fr") ? lang : 'en',
            keys: StringHelper.removeSpecialCharacters(inKey),
            lat: lat,
            long: long,
            d: 50,
            start: start || 0,
            rows: rows || 50
        };

        return this.getApiRequest(this.getUrl().careerServiceBase + "byKeywordsAndLatLong?", params);
    },

    getAllJobs: function getAllJobs(lang) {
        var params;

        if (lang) {
            if (lang == "es" || lang == "fr") {
                params = {
                    lang: lang
                };
            }
        }

        return this.getApiRequest(this.getUrl().careersByIds, params);
    },

    getHotJobs: function getHotJobs(location, lang) {
        var results;
        var params = {
            location: location,
            d: 50,
            start: 0,
            rows: 25
        };
        if (lang) {
            if (lang == "es" || lang == "fr") {
                params = {
                    location: location,
                    d: 50,
                    start: 0,
                    rows: 25,
                    lang: lang
                };
            }
        }
        if (params.location) {
            results = this.getApiRequest(this.getUrl().careersByLocation, params);
        } else {
            params = {
                rows: 25,
                lang: lang || 'en'
                //http://careers-dev-services.wendys.com/WendysJobService/jobs/byLatestJobPosting
            };results = this.getApiRequest(this.getUrl().careersByLatestJobPosting, params);
        }

        return results;
    }

});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/service_clients/careerJobServiceClient.js
// module id = 773
// module chunks = 0